<div class="customPanel">

  <!-- TITLE SECTION -->
  <!-- HOME -->
  <h1 *ngIf="!uploadImageView && !modelListView && !modelView && !deleteModeloView" class="textM" style="text-align: center; height: 7%; margin: auto" mat-dialog-title>
    {{this.localiser.get("options.title")}}
  </h1>

  <!-- TITLE SECTION -->
  <!-- UPLOAD IMAGE VIEW -->
  <h1 *ngIf="uploadImageView && !modelListView && !modelView && !deleteModeloView" class="textM" style="text-align: center; height: 7%; margin: auto" mat-dialog-title>
    Images
  </h1>

  <!-- TITLE SECTION -->
  <!-- MODEL LIST VIEW -->
  <h1 *ngIf="!uploadImageView && modelListView && !modelView && !deleteModeloView" class="textM" style="text-align: center; height: 7%; margin: auto" mat-dialog-title>
    Model List
  </h1>

  <!-- TITLE SECTION -->
  <!-- MODEL VIEW -->
  <h1 *ngIf="!uploadImageView && !modelListView && modelView && !deleteModeloView" class="textM" style="text-align: center; height: 7%; margin: auto" mat-dialog-title>
    Model
  </h1>

  <!-- TITLE SECTION -->
  <!-- DELETE MODELO VIEW -->
  <h1 *ngIf="!uploadImageView && !modelListView && !modelView && deleteModeloView" class="textM" style="text-align: center; height: 7%; margin: auto" mat-dialog-title>
    Delete Model
  </h1>

  <!-- CONTENT SECTION -->
  <!-- HOME -->
  <div *ngIf="!uploadImageView && !modelListView && !modelView && !deleteModeloView" mat-dialog-content class="bodyFormHome">

    <div (click)="toUploadImageView()" class="homeButton marginAuto">
      <div style="height: 70%">
        <span class="material-icons-outlined textXXL homeButtonIcon centerVert">
          photo_library
        </span>
      </div>
      <div style="height: 30%" class="homeButtonIcon">
        <h3 style="color: black;" class="textS+">Images</h3>
      </div>
    </div>

    <div (click)="toModelListView()" class="homeButton marginAuto">
      <div style="height: 70%">
        <span class="material-icons-outlined textXXL homeButtonIcon centerVert">
          photo_library
        </span>
      </div>
      <div style="height: 30%" class="homeButtonIcon">
        <h3 style="color: black;" class="textS+">Models</h3>
      </div>
    </div>

  </div>

  <!-- CONTENT SECTION -->
  <!-- UPLOAD IMAGE VIEW -->
  <div *ngIf="uploadImageView && !modelListView && !modelView && !deleteModeloView" mat-dialog-content class="bodyFormUpload">
    <div class="row" style="width: 100%; margin: 2% 0 0;">
      <label for="files" style="margin: auto;" class="btn buttonCst textS+">Select picture</label>
      <input id="files" style="display: none;" type="file" (change)="onSelectFile($event)">
    </div>
    <div *ngIf="previewImageBool">
      <div *ngIf="selectedFile != undefined" class="row">

        <h3 style="margin: auto; text-align: center" class="textXS">
        <span class="material-icons-outlined textXS">
        check
      </span>
          {{this.nameOriginalFile}}
        </h3>
      </div>
      <div class="row" style="margin: 2% 0">
        <div class="col">
          <div class="row inputNameRow">
            <div class="col-3 marginAuto">
              <h3 class="textS+ marginAuto">{{this.localiser.get('select_floorplans.name')}}</h3>
            </div>
            <div class="col-9">
              <input [(ngModel)]="nameFile" placeholder="{{this.localiser.get('select_floorplans.name')}}"
                     type="text" class="inputText textS+" [ngClass]="{'nameFileRed': nameFileEmpty}" (input)="changeFileName()" maxlength="30"
                     style="margin: auto">
            </div>
          </div>
          <div class="row previewImageRow" style="margin-top: 3%">
            <img [src]="uploadedImageUrl" class="marginAuto" style="max-height: 100%; max-width: 50%; background-color: white;">
          </div>
        </div>
      </div>
    </div>

    <!-- GRID OF IMAGES -->
    <div style="border-top: 1px solid white; margin-top: 2%">
      <div class="row" *ngFor="let i of [0,1,2,3,4,5]">
        <div class="col-3" style="height: 25vh" *ngFor="let image of imagesByEmpresa.slice((i * 4),4 + (i * 4))">
          <div (click)="onClickPreviewImage(image)" style="height: 100%">
            <div class="row" style="height: 80%; width: 100%; margin: auto;">
              <img style="max-width: 90%; max-height: 90%; background-color: white; margin: auto;" src="{{image.rutaImagen}}">
            </div>
            <div class="row" style="height: 20%; margin: auto;">
              <h3 style="margin: auto; text-overflow: ellipsis; overflow: hidden;" class="textS">{{image.nombre}}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- CONTENT SECTION -->
  <!-- MODEL LIST VIEW -->
  <div *ngIf="!uploadImageView && modelListView && !modelView && !deleteModeloView" mat-dialog-content class="bodyFormUpload">
    <div class="row" style="text-align: center; height: 15%">
      <button class="customButtonColor textS+" style="margin: auto" mat-button (click)="toCreateModelo()">New modelo</button>
    </div>
    <div style="height: 85%; overflow-y: auto">
      <div *ngFor="let modelo of imagenesModeloByEmpresa" class="row modelListRow">
        <div style="margin: auto" class="col-5">
          <h3 class="textS+" style="margin: auto">{{modelo.nombre}}</h3>
        </div>

        <div class="col-1" style="height: 100%">
          <div class="row centerVert" style="height: 70%; display: flex">
            <img *ngIf="getImgById(modelo.imgOk) != undefined" style="max-width: 100%; max-height: 100%; background-color: white; margin: auto;" src="{{getImgById(modelo.imgOk).rutaImagen}}">
            <div *ngIf="getImgById(modelo.imgOk) == undefined" style="background-color: #f6ff00; margin: auto; width: 90%; height: 90%"></div>
          </div>
        </div>
        <div class="col-1" style="height: 100%">
          <div class="row centerVert" style="height: 70%; display: flex">
            <img *ngIf="getImgById(modelo.imgInactiv) != undefined" style="max-width: 100%; max-height: 100%; background-color: white; margin: auto;" src="{{getImgById(modelo.imgInactiv).rutaImagen}}">
            <div *ngIf="getImgById(modelo.imgInactiv) == undefined" style="background-color: lightskyblue; margin: auto; width: 90%; height: 90%"></div>
          </div>
        </div>
        <div class="col-1" style="height: 100%">
          <div class="row centerVert" style="height: 70%; display: flex">
            <img *ngIf="getImgById(modelo.imgErr) != undefined" style="max-width: 100%; max-height: 100%; background-color: white; margin: auto;" src="{{getImgById(modelo.imgErr).rutaImagen}}">
            <div *ngIf="getImgById(modelo.imgErr) == undefined" style="background-color: #FF0C41; margin: auto; width: 90%; height: 90%"></div>
          </div>
        </div>

        <div class="col-2" style="display: flex">
          <!--<button class="customButtonColor textS+" mat-button (click)="toEditModelo(modelo.idModelo)">Edit</button>-->
          <span (click)="toEditModelo(modelo.idModelo)" class="material-icons-outlined textXM marginAuto cursorPointer navigateBefore">
            edit
          </span>
        </div>
        <div class="col-2" style="display: flex">
          <!--<button class="customButtonColor textS+" mat-button (click)="toDeleteModeloView(modelo.idModelo)">Delete</button>-->
          <span (click)="toDeleteModeloView(modelo)" class="material-icons-outlined textXM marginAuto cursorPointer navigateBefore">
            delete
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- CONTENT SECTION -->
  <!-- MODEL VIEW -->
  <div *ngIf="!uploadImageView && !modelListView && modelView && !deleteModeloView" mat-dialog-content class="bodyFormUpload">
    <div class="row" style="margin: 2% 0">
      <div class="col">
        <div class="row inputNameRow">
          <h3 class="textS+">{{this.localiser.get('select_floorplans.name')}}</h3>
        </div>
        <div class="row inputNameRow">
          <input [ngClass]="{nameModelRed: modeloNombreEmpty && (modeloNombre == '' || modeloNombre == undefined)}" [(ngModel)]="modeloNombre" placeholder="{{this.localiser.get('select_floorplans.name')}}"
                 type="text" class="inputText textS+" maxlength="30" style="margin: auto">
        </div>
        <div class="row marginAuto" style="height: 14vw; margin-top: 4%">
          <div class="col" style="height: 100%">
            <div class="row" style="height: 20%">
              <h3 class="textS marginAuto">ImgOK</h3>
              <span (click)="deleteImageOfModel('imgOk')" class="material-icons-outlined textS+ modelButtonDeleteImageIcon">
                cancel
              </span>
            </div>
            <div class="row" style="height: 80%">
              <img [ngClass]="{selectedImage: selectedImageToEdit == 'imgOk'}" *ngIf="imgOk != undefined" (click)="selectImageToEdit('imgOk')" style="max-width: 100%; max-height: 100%; background-color: white; margin: auto;" src="{{imgOk.rutaImagen}}">
              <div [ngClass]="{selectedImage: selectedImageToEdit == 'imgOk'}" *ngIf="imgOk == undefined" (click)="selectImageToEdit('imgOk')" style="background-color: #f6ff00; margin: auto; width: 90%; height: 90%"></div>
            </div>
          </div>
          <div class="col" style="height: 100%">
            <div class="row" style="height: 20%">
              <h3 class="textS marginAuto">ImgInactiv</h3>
              <span (click)="deleteImageOfModel('imgInactiv')" class="material-icons-outlined textS+ modelButtonDeleteImageIcon">
                cancel
              </span>
            </div>
            <div class="row" style="height: 80%">
              <img [ngClass]="{selectedImage: selectedImageToEdit == 'imgInactiv'}" *ngIf="imgInactiv != undefined" (click)="selectImageToEdit('imgInactiv')" style="max-width: 100%; max-height: 100%; background-color: white; margin: auto;" src="{{imgInactiv.rutaImagen}}">
              <div [ngClass]="{selectedImage: selectedImageToEdit == 'imgInactiv'}" *ngIf="imgInactiv == undefined" (click)="selectImageToEdit('imgInactiv')" style="background-color: lightskyblue; margin: auto; width: 90%; height: 90%"></div>
            </div>
          </div>
          <div class="col" style="height: 100%">
            <div class="row" style="height: 20%">
              <h3 class="textS marginAuto">ImgErr</h3>
              <span (click)="deleteImageOfModel('imgErr')" class="material-icons-outlined textS+ modelButtonDeleteImageIcon">
                cancel
              </span>
            </div>
            <div class="row" style="height: 80%">
              <img [ngClass]="{selectedImage: selectedImageToEdit == 'imgErr'}" *ngIf="imgErr != undefined" (click)="selectImageToEdit('imgErr')" style="max-width: 100%; max-height: 100%; background-color: white; margin: auto;" src="{{imgErr.rutaImagen}}">
              <div [ngClass]="{selectedImage: selectedImageToEdit == 'imgErr'}" *ngIf="imgErr == undefined" (click)="selectImageToEdit('imgErr')" style="background-color: #FF0C41; margin: auto; width: 90%; height: 90%"></div>
            </div>
          </div>
        </div>

        <!-- GRID OF IMAGES -->
        <div style="border-top: 1px solid white; margin-top: 2%">
          <div class="row" *ngFor="let i of [0,1,2,3,4,5]">
            <div class="col-3" style="height: 25vh" *ngFor="let image of imagesByEmpresa.slice((i * 4),4 + (i * 4))">
              <div (click)="selectImageToAddToModel(image)" style="height: 100%">
                <div class="row" style="height: 80%; width: 100%; margin: auto;">
                  <img [ngClass]="{blurImage: selectedImageToEdit == undefined, selectedImage: isImageSelected(image)}" style="max-width: 90%; max-height: 90%; background-color: white; margin: auto;" src="{{image.rutaImagen}}">
                </div>
                <div class="row" style="height: 20%; margin: auto;">
                  <h3 [ngClass]="{blurText: selectedImageToEdit == undefined}" style="margin: auto; text-overflow: ellipsis; overflow: hidden;" class="textS">{{image.nombre}}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- CONTENT SECTION -->
  <!-- DELETE MODELO VIEW -->
  <div *ngIf="!uploadImageView && !modelListView && !modelView && deleteModeloView" mat-dialog-content class="bodyFormUpload">
    <div class="row" style="text-align: center; height: 15%">
      <h3 class="textS+ marginAuto">Are you sure you want to delete the model:</h3>
    </div>
    <div class="col">
      <div class="row inputNameRow">
        <h3 class="textM marginAuto">{{this.deleteModeloVar.nombre}}</h3>
      </div>
      <div class="row marginAuto" style="height: 14vw; margin-top: 4%">
        <div class="col" style="height: 100%">
          <div class="row" style="height: 20%">
            <h3 class="textS marginAuto">ImgOK</h3>
          </div>
          <div class="row" style="height: 80%">
            <img *ngIf="getImgById(this.deleteModeloVar.imgOk) != undefined" style="max-width: 100%; max-height: 100%; background-color: white; margin: auto;" src="{{getImgById(this.deleteModeloVar.imgOk).rutaImagen}}">
            <div *ngIf="getImgById(this.deleteModeloVar.imgOk) == undefined" style="background-color: #f6ff00; margin: auto; width: 90%; height: 90%"></div>
          </div>
        </div>
        <div class="col" style="height: 100%">
          <div class="row" style="height: 20%">
            <h3 class="textS marginAuto">ImgInactiv</h3>
          </div>
          <div class="row" style="height: 80%">
            <img *ngIf="getImgById(this.deleteModeloVar.imgInactiv) != undefined" style="max-width: 100%; max-height: 100%; background-color: white; margin: auto;" src="{{getImgById(this.deleteModeloVar.imgInactiv).rutaImagen}}">
            <div *ngIf="getImgById(this.deleteModeloVar.imgInactiv) == undefined" style="background-color: lightskyblue; margin: auto; width: 90%; height: 90%"></div>
          </div>
        </div>
        <div class="col" style="height: 100%">
          <div class="row" style="height: 20%">
            <h3 class="textS marginAuto">ImgErr</h3>
          </div>
          <div class="row" style="height: 80%">
            <img *ngIf="getImgById(this.deleteModeloVar.imgErr) != undefined" style="max-width: 100%; max-height: 100%; background-color: white; margin: auto;" src="{{getImgById(this.deleteModeloVar.imgErr).rutaImagen}}">
            <div *ngIf="getImgById(this.deleteModeloVar.imgErr) == undefined" style="background-color: #FF0C41; margin: auto; width: 90%; height: 90%"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- BOTTOM BUTTONS SECTION -->
  <!-- HOME OPTIONS -->
  <div *ngIf="!uploadImageView && !modelListView && !modelView && !deleteModeloView" mat-dialog-actions>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS+" mat-button (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
    </div>
  </div>

  <!-- BOTTOM BUTTONS SECTION -->
  <!-- UPLOAD IMAGE VIEW -->
  <div *ngIf="uploadImageView && !modelListView && !modelView && !deleteModeloView" mat-dialog-actions>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS+" mat-button (click)="toHome()">{{this.localiser.get("button.back")}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS+" mat-button (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
    </div>
    <div *ngIf="previewImageBool" class="col" style="text-align: center">
      <button *ngIf="!connecting && selectedFile != undefined" [disabled]="nameFileEmpty" mat-button (click)="performUpload()"
              class="customButtonColorDone textS+">Upload</button>

      <button *ngIf="!connecting && selectedPreviewImage != undefined" [disabled]="nameFileEmpty" mat-button (click)="updateImageName()"
              class="customButtonColorDone textS+">Update</button>

      <button *ngIf="connecting" class="customButtonColorDone textS+">
        <mat-progress-spinner class="spinner" color="primary" mode="indeterminate" diameter="30">
        </mat-progress-spinner>
      </button>
    </div>

  </div>

  <!-- BOTTOM BUTTONS SECTION -->
  <!-- MODEL LIST VIEW -->
  <div *ngIf="!uploadImageView && modelListView && !modelView && !deleteModeloView" mat-dialog-actions>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS+" mat-button (click)="toHome()">{{this.localiser.get("button.back")}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS+" mat-button (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
    </div>
  </div>

  <!-- BOTTOM BUTTONS SECTION -->
  <!-- MODEL VIEW -->
  <div *ngIf="!uploadImageView && !modelListView && modelView && !deleteModeloView" mat-dialog-actions>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS+" mat-button (click)="toModelListView()">{{this.localiser.get("button.back")}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS+" mat-button (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button *ngIf="!connecting && idModelo == undefined" class="customButtonColorDone textS+" mat-button (click)="saveModelo()">SAVE</button>
      <button *ngIf="!connecting && idModelo != undefined" class="customButtonColorDone textS+" mat-button (click)="saveModelo()">EDIT</button>
      <button *ngIf="connecting" class="customButtonColorDone textS+" mat-button>
        <mat-progress-spinner class="spinner" color="primary" mode="indeterminate" diameter="30">
        </mat-progress-spinner>
      </button>
    </div>
  </div>

  <!-- BOTTOM BUTTONS SECTION -->
  <!-- DELETE MODEL VIEW -->
  <div *ngIf="!uploadImageView && !modelListView && !modelView && deleteModeloView" mat-dialog-actions>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS+" mat-button (click)="toModelListView()">{{this.localiser.get("button.back")}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button *ngIf="!connecting && idModelo == undefined" class="customButtonColorDelete textS+" mat-button (click)="deleteModelo()">Delete</button>
      <button *ngIf="connecting" class="customButtonColorDone textS+" mat-button>
        <mat-progress-spinner class="spinner" color="warn" mode="indeterminate" diameter="30">
        </mat-progress-spinner>
      </button>
    </div>
  </div>

</div>
